var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import React, { useState, useEffect, useRef } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Translate from '../../components/Translate';
import PropTypes from 'prop-types';
import translate from '../../lib/utils/translate';
import cn from 'classnames';
import withValidation from '../../lib/WithValidation';
import email from '../../lib/WithValidation/rules/email';
import require from '../../lib/WithValidation/rules/required';

var KEY_CODE = {
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight'
};

var ActivationCode = function ActivationCode(_ref) {
  var _ref$length = _ref.length,
      length = _ref$length === undefined ? 4 : _ref$length,
      _ref$code = _ref.code,
      code = _ref$code === undefined ? '' : _ref$code,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === undefined ? true : _ref$autoFocus,
      onChange = _ref.onChange,
      isLoading = _ref.isLoading,
      name = _ref.name,
      status = _ref.status,
      statusText = _ref.statusText;

  var boxes = new Array(length).fill('');

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var inputRef = useRef();

  useEffect(function () {
    if (autoFocus && !code.length) {
      inputRef.current.focus();
      setActiveIndex(0);
    }
  }, [autoFocus, code]);

  useEffect(function () {
    inputRef.current.value = code;
  }, [code]);

  var setCaretPosition = function setCaretPosition(from, to) {
    inputRef.current.focus();
    inputRef.current.setSelectionRange(from, to);
  };

  var handleKeyPress = function handleKeyPress(key, v) {
    switch (key) {
      case KEY_CODE.BACKSPACE || KEY_CODE.DELETE:
        {
          setActiveIndex(v.length);
          setCaretPosition(v.length, v.length);
          onChange(v);
          break;
        }

      case KEY_CODE.ARROW_LEFT:
        {
          if (activeIndex === 0) return;
          setActiveIndex(activeIndex - 1);
          setCaretPosition(activeIndex - 1, activeIndex);
          break;
        }
      case KEY_CODE.ARROW_RIGHT:
        {
          if (activeIndex === 3) return;
          setActiveIndex(activeIndex + 1);
          setCaretPosition(activeIndex + 1, activeIndex + 2);
          break;
        }

      default:
        {
          setActiveIndex(v.length);
          setCaretPosition(v.length, v.length + 1);
          onChange(v);
        }
    }
  };

  var handleFocus = function handleFocus(i) {
    setCaretPosition(i, i + 1);
    setActiveIndex(i);
  };

  var handleBlur = function handleBlur() {
    setActiveIndex(-1);
  };

  return React.createElement(
    'div',
    {
      className: cn('ActivationCode', {
        'tg-input__status-failure': status === 'failure'
      }) },
    React.createElement(
      'div',
      { className: 'ActivationCode__wrapper' },
      React.createElement(
        'div',
        { className: 'ActivationCode__label' },
        React.createElement(Translate, {
          id: 'label.activation_code',
          defaultMessage: 'Activation code'
        })
      ),
      React.createElement(
        'div',
        { className: 'ActivationCode__boxes' },
        React.createElement('input', {
          className: 'ActivationCode__input',
          type: 'text',
          autoComplete: 'one-time-code',
          inputMode: 'decimal',
          name: name,
          ref: inputRef,
          maxLength: length,
          onKeyUp: function onKeyUp(_ref2) {
            var key = _ref2.key,
                target = _ref2.target;
            return handleKeyPress(key, target.value);
          },
          onBlur: handleBlur
        }),
        boxes.map(function (_, i) {
          return React.createElement(
            'div',
            {
              className: cn('ActivationCode__box', {
                'ActivationCode__box--focused': !isLoading && i === activeIndex,
                'ActivationCode__box--error': status === 'failure',
                'ActivationCode__box--empty': i === activeIndex && !code[i]
              }),
              key: i,
              onClick: function onClick() {
                return handleFocus(i);
              } },
            code[i]
          );
        })
      )
    ),
    React.createElement(
      'div',
      { className: 'tg-input__status-text' },
      statusText
    )
  );
};

var ActivateWidget = function ActivateWidget(_ref3) {
  var intl = _ref3.intl,
      _ref3$email = _ref3.email,
      pEmail = _ref3$email === undefined ? '' : _ref3$email,
      _ref3$code = _ref3.code,
      pCode = _ref3$code === undefined ? '' : _ref3$code,
      onSubmit = _ref3.onSubmit,
      onResend = _ref3.onResend,
      errors = _ref3.errors;

  var _useState3 = useState(pCode),
      _useState4 = _slicedToArray(_useState3, 2),
      code = _useState4[0],
      setCode = _useState4[1];

  var _useState5 = useState(pEmail),
      _useState6 = _slicedToArray(_useState5, 2),
      email = _useState6[0],
      setEmail = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var pattern = new RegExp('^[0-9]{4}$');

  useEffect(function () {
    if (email && pattern.test(code)) handleSubmit();
  }, [code, email]);

  var handleResend = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return onResend(email);

            case 4:
              setIsLoading(false);
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](1);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 7]]);
    }));

    return function handleResend() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleSubmit = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return onSubmit(email, code);

            case 4:
              setCode('');
              setIsLoading(false);
              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](1);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[1, 8]]);
    }));

    return function handleSubmit() {
      return _ref5.apply(this, arguments);
    };
  }();

  return React.createElement(
    'div',
    { className: 'ActivateWidget' },
    React.createElement(
      'div',
      { className: 'ActivateWidget__message' },
      React.createElement(Translate, {
        id: 'label.activation_code_received',
        defaultMessage: 'An activation code has been sent to your email address and your phone number'
      })
    ),
    React.createElement(
      'div',
      { className: 'form' },
      !pEmail && React.createElement(Input, {
        autoFocus: true,
        label: translate({ id: 'label.email', defaultMessage: 'Email' }, intl),
        value: email || '',
        onChange: function onChange(e) {
          return setEmail(e.target.value);
        },
        name: 'Email',
        status: errors.Email ? 'failure' : 'idle',
        statusText: errors.Email && translate({ id: errors.Email }, intl)
      }),
      React.createElement(ActivationCode, {
        onChange: setCode,
        code: code,
        autoFocus: Boolean(pEmail),
        isLoading: isLoading,
        name: 'ActivationCode',
        status: errors.ActivationCode ? 'failure' : 'idle',
        statusText: errors.ActivationCode && translate({ id: errors.ActivationCode }, intl)
      }),
      React.createElement(
        Button,
        {
          isLoading: isLoading,
          className: 'button primary wide',
          onClick: handleSubmit },
        React.createElement(Translate, { id: 'action.activate', defaultMessage: 'Activate' })
      )
    ),
    React.createElement('hr', { className: 'hr--1' }),
    React.createElement(
      'div',
      { className: 'ActivateWidget__resend' },
      React.createElement(Translate, {
        id: 'action.send_new_code',
        defaultMessage: 'Didn\'t get code?'
      })
    ),
    React.createElement(
      Button,
      {
        isLoading: isLoading,
        className: 'button tertiary wide',
        onClick: handleResend },
      React.createElement(Translate, {
        id: 'action.resend_activation_code',
        defaultMessage: 'Resend activation code'
      })
    )
  );
};

ActivateWidget.propTypes = {
  /** Default value for email field */
  email: PropTypes.string,
  /** Default value for code field */
  code: PropTypes.string,
  /** The submission function firing when submitting the form. Returns data + callback to call once done */
  onSubmit: PropTypes.func.isRequired,
  /** The submission function firing when resending the code. Returns data + callback to call once done */
  onResend: PropTypes.func.isRequired
};

ActivateWidget.defaultProps = {
  onSubmit: Function,
  onResend: Function
};

var rules = {
  Email: [[require, 'error.empty.email'], [email, 'error.condition.email']],
  ActivationCode: [[require, 'error.empty.activation_code']]
};

export default compose(withValidation(rules), injectIntl)(ActivateWidget);